import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { take } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {

  pdfUrl:any;
  safePdfUrl: SafeResourceUrl;

  constructor(
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.userService.getTermsOfUse().pipe(take(1)).subscribe({
      next: (response) => {
        const s3Url = response?.touDetails?.[0]?.tou_document_url;
        const pdfUrl = `${s3Url}#toolbar=0&navpanes=0&scrollbar=0`;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
      },
      error: (err) => {
      },
    });
  }

}
